import * as React from 'react'
import {PublicPage} from '../../View/PublicPage'
import {LoginFormAction} from '../../Components/LoginForm/LoginFormActions'
import {LoginInputs} from '../../Components/LoginForm/LoginFormView'
import {LoginForm} from '../../Components/LoginForm/LoginFormState'
import RaisedButton from 'material-ui/RaisedButton'
import injectSheet from 'react-jss'
import {WithClasses} from '../../View/Helper'

const styles = {
    loginForm: {
        textAlign: 'center',
        padding: '16px'
    },
}

interface Properties {
    readonly state: LoginForm,
    readonly dispatch: (action: LoginFormAction) => void
}

export const Login =
    injectSheet<Properties>(styles)(
        ({classes, state, dispatch}: WithClasses<Properties>) => (
            <PublicPage>
                <form
                    className={classes.loginForm}
                    onSubmit={(event) => {
                        event.preventDefault()
                        dispatch({
                            type: 'Submit',
                        })
                    }}
                >
                    <LoginInputs
                        autofocus={'Email'}
                        state={state}
                        dispatch={dispatch}
                    />
                    <RaisedButton
                        label="Login"
                        type="submit"
                        primary={true}
                        className="login__btn"
                        disabled={state.loading}
                    />
                </form>
            </PublicPage>
        )
    )


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/Login/LoginView.tsx